import React from "react";
import {StoreProductForm} from "../components/store-products-form";

export const StoreProductPage: React.FC = () => <StoreProductForm/>;
